import { type KeyedOption } from "../../shared/models";

interface LensSpaceOptionResource {
    id: string;
    name: string;
}

export const makeLensSpaceOptions = (lensSpaces: readonly LensSpaceOptionResource[]): KeyedOption[] => {
    const lensSpacesById = new Map<string, LensSpaceOptionResource>();

    for (const lensSpace of lensSpaces) {
        if (!lensSpacesById.has(lensSpace.id)) {
            lensSpacesById.set(lensSpace.id, lensSpace);
        }
    }

    return [...lensSpacesById.values()]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((lensSpace) => ({
            key: lensSpace.id,
            value: lensSpace.id,
            label: lensSpace.name,
        }));
};
